import * as React from 'react';
import { cn } from '../lib/utils';
import { fieldClassName, useFieldControl } from '../lib/field';

export type SelectProps = React.SelectHTMLAttributes<HTMLSelectElement> & {
  children?: React.ReactNode;
  /**
   * Sized like a small button (32px, 12px medium text), for a toolbar beside
   * `Button size="sm"`; on touch devices it keeps a 44px target.
   */
  compact?: boolean;
};

// A chevron in the muted foreground color (#526071), drawn as the select's
// background so the control stays a single element callers can size.
const chevron =
  "bg-[url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23526071' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\")] bg-[length:1rem] bg-[position:right_0.75rem_center] bg-no-repeat";

/**
 * The platform's own select, styled as a Clear field: native keyboard, touch
 * and screen-reader behavior on every device.
 */
export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, children, compact = false, ...props }, ref) => (
    <select
      ref={ref}
      className={cn(
        fieldClassName,
        chevron,
        'flex cursor-pointer appearance-none [&>option]:bg-popover [&>option]:text-popover-foreground',
        compact
          ? 'h-8 bg-[length:0.875rem] bg-[position:right_0.625rem_center] py-1 pl-3 pr-8 text-xs font-medium pointer-coarse:h-11'
          : 'h-9 py-1.5 pl-3 pr-9',
        className
      )}
      {...useFieldControl(props)}
    >
      {children}
    </select>
  )
);

Select.displayName = 'Select';
